import * as React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { cn } from "@/lib/utils";

const base =
  "h-auto min-w-[150px] rounded-lg border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 shadow-none focus:ring-2 focus:ring-primary/20";

// Accessible, keyboard-friendly select (radix) with a simple options API.
// options: [{ value, label }]. Works inside dialogs/drawers (portalled).
export function FieldSelect({ value, onChange, options, placeholder, testId, className, disabled }) {
  return (
    <Select value={value ?? undefined} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testId} className={cn(base, className)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="z-[60] max-h-72">
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={testId ? `${testId}-option-${o.value}` : undefined}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
